module.exports = __webpack_public_path__ + "static/img/14@2x.2f9b1e0e.png";